// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9603851e","180":"e2ae8136","246":"a6440b0b","419":"516e98fc","631":"9c5a8fd8","738":"a6ef015f","757":"d6fec662","774":"8f4f9208","820":"342220c3","910":"8a588c5d"}[chunkId] + ".chunk.js";
};